// extracted by mini-css-extract-plugin
export default {"item":"promotion-item_item__a0zf4"};